import { financeOperatorsApi } from 'entities/financeOperations/model';
import { toast } from 'react-toastify';
import { HTTP_METHODS } from 'shared/consts';

const updateFinanceOperatorReasonApi = financeOperatorsApi.injectEndpoints({
  endpoints: (builder) => ({
    updateReason: builder.mutation({
      query: ({ id, data }) => ({
        url: `/wallet/admin/withdrawal_services_types/downtimes/${id}/`,
        method: HTTP_METHODS.PATCH,
        body: data,
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно обновили причину', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'FinanceOperationId' }];
      },
    }),
  }),
});

export const { useUpdateReasonMutation } = updateFinanceOperatorReasonApi;
